import { Trans } from '@lingui/react';
import { stripeProducts } from '../../../environments/environment';
import CheckIcon from '@mui/icons-material/Check';
import { Stack } from '@startuptools/ui/Stack';
import { GROW_SHAREHOLDERS_LIMIT, STARTER_SHAREHOLDERS_LIMIT } from '@startuptools/business-ui/UpgradeBanner';

const getBulletPoints = (productId: string) => {
  // Do not remove legacy products unless it's confirmed nobody is subscribed to them anymore
  switch (productId) {
    case stripeProducts.shareRegistry: {
      return [
        { id: 1, text: <Trans id="More than 5 shareholders" />, class: '' },
        { id: 1, text: <Trans id="Stakeholder Portal" />, class: '' },
        { id: 1, text: <Trans id="Gets cases from Bolagsverket" />, class: '' },
      ];
    }
    case stripeProducts.startup: {
      return [
        { id: 1, text: <Trans id="Everything from free" />, class: 'font-semibold' },
        {
          id: 1,
          text: <Trans id="Share Register ({shCount} shareholders)" values={{ shCount: STARTER_SHAREHOLDERS_LIMIT }} />,
          class: '',
        },
        { id: 1, text: <Trans id="Document handling" />, class: '' },
        { id: 1, text: <Trans id="Employee agreement" />, class: '' },
        { id: 1, text: <Trans id="NDA" />, class: '' },
        { id: 1, text: <Trans id="E-Signing" />, class: '' },
        { id: 1, text: <Trans id="Chat support" />, class: '' },
      ];
    }
    case stripeProducts.grow: {
      return [
        { id: 1, text: <Trans id="Everything from Starter" />, class: 'font-semibold' },
        {
          id: 1,
          text: <Trans id="Share Register ({shCount} shareholders)" values={{ shCount: GROW_SHAREHOLDERS_LIMIT }} />,
          class: '',
        },
        { id: 1, text: <Trans id="Stakeholder portal" />, class: '' },
        { id: 1, text: <Trans id="Board portal" />, class: '' },
        { id: 1, text: <Trans id="Annual meetings" />, class: '' },
        { id: 1, text: <Trans id="Options program or investment: 9 950 SEK" />, class: '' },
        { id: 1, text: <Trans id="1h introduction of the plattform with us" />, class: '' },
      ];
    }
    case stripeProducts.pro: {
      return [
        { id: 1, text: <Trans id="Share register covering your needs" />, class: '' },
        { id: 1, text: <Trans id="Board portal" />, class: '' },
        { id: 1, text: <Trans id="Annual meetings" />, class: '' },
        { id: 1, text: <Trans id="Tailored plans for stock option programs and share issues" />, class: '' },
        { id: 1, text: <Trans id="Stakeholder portal" />, class: '' },
        { id: 1, text: <Trans id="Custom agreement templates in the plattform" />, class: '' },
        { id: 1, text: <Trans id="Cap Table tools" />, class: '' },
        { id: 1, text: <Trans id="Assistance with execution from our team" />, class: '' },
        { id: 1, text: <Trans id="Company valuation, regularly or on demand" />, class: '' },
        { id: 1, text: <Trans id="Juridical consultations" />, class: '' },
        { id: 1, text: <Trans id="Support by phone" />, class: '' },
      ];
    }
  }
};

export const BulletPoints = ({ productId }: { productId: string }) => {
  return getBulletPoints(productId)?.map(b => (
    <Stack direction="row" key={b.id} className={b.class} fontSize="small" alignItems="center">
      <CheckIcon color="success" fontSize="small" />
      {b.text}
    </Stack>
  ));
};
